import React from 'react';

const Footer = () => {
    return (
        <footer className="animate-fade-in">
            © 2026 KANAKO TAGA • PRODUCT MANAGER • FULL-STACK DEVELOPER • VANCOUVER, BC, CANADA
        </footer>
    );
};

export default Footer;
